// test2680
(2680 && 0);
